import { format, parseISO } from "date-fns";
import { pt as locale } from "date-fns/locale";

const formatDate = (value = new Date(), BRFormat = "dd MMM") => {
  return format(parseISO(value), BRFormat, { locale });
};

const formatWeekDay = (value = new Date(), BRFormat = "EEE") => {
  return format(parseISO(value), BRFormat, { locale });
};

export { formatDate, formatWeekDay };
